export const PROFILE = '[PROFILE]'

export const GET_PROFILES = `${PROFILE} GET_PROFILES`
export const SET_PROFILES = `${PROFILE} SET_PROFILES`
